import React from 'react'
import { MdStar } from 'react-icons/md'

type StarRatingProps = {
  maxRating?: number
  size?: number
  rating?: number // decimal allowed
  className?: string
  IconClassName?: string
}

const StarRating: React.FC<StarRatingProps> = ({
  maxRating = 5,
  size = 25,
  rating = 0,
  className = '',
  IconClassName = 'text-amber_yellow',
}) => {
  const stars = Array.from({ length: maxRating }, (_, i) => i + 1)

  let overRideRating

  switch (Number(rating)) {
    case 4.9:
    case 4.8:
      overRideRating = 4.7
      break
    case 4.1:
      overRideRating = 4.2
      break
    case 3.1:
      overRideRating = 3.2
      break
    case 2.1:
      overRideRating = 2.2
      break
    case 1.1:
      overRideRating = 1.2
      break
    default:
      overRideRating = Number(rating)
  }

  return (
    <div className={`flex gap-[2px] items-center ${className}`}>
      {stars.map((star) => {
        // Calculate fill % for this star (0–100)
        const fillPercent =
          Math.min(Math.max(overRideRating - (star - 1), 0), 1) * 100

        return (
          <div key={star} className="relative" style={{ width: size, height: size }}>
            {/* Empty star */}
            <MdStar size={size} className={`text-gray-300 ${IconClassName}`} />

            {/* Filled star overlay */}
            <div
              className='absolute top-0 left-0 overflow-hidden'
              style={{ width: `${fillPercent}%` }}
            >
              <MdStar size={size} className={`${IconClassName}`} />
            </div>
          </div>
        )
      })}

      {/* Optional numeric rating */}
      {/* <span className="ml-2 text-gray-700 font-medium">{rating?.toFixed(1)}</span> */}
    </div>
  )
}

export default StarRating
